
import Vue from 'vue';
import App from './App';
import router from './router';
/**
 * import axios to do net work request
 * 优势：异步请求，减少回调
 */
import axios from 'axios';
import QS from 'qs';
/**
 * import element-ui to reduce the UI work
 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css';
import VueWow from 'vue-wow';
import Mint from 'mint-ui';
import "mint-ui/lib/style.css";
Vue.use(Mint);
// mount with global
Vue.use(VueWow);
Vue.use(ElementUI);
// Vue.use(VueWow);
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);

Vue.prototype.$axios = axios;
Vue.prototype.qs = QS;
Vue.config.productionTip = false;

window.broadcast = new Vue();
window.webResource = [];
window.loadedResource = [];
/**
 * check resource if load complete
 * @type {boolean}
 */
window.loadComplete = true;
/**
 * article url
 * @type {string}
 */
window.articleParam = "";
/**
 * 0:index;
 * 1:elabIntroduce;
 * 2:elabDo;
 * 3:news;
 * 4:article;
 * 5:careers
 * @type {number}
 */
window.itemType = 0;
/**
 * register common ui
 */
import menu from './components/menu/menu.vue';
import head from './components/head/head.vue';
import bottom from './components/bottom/bottom.vue';
import elabVideo from './components/elabVideo/elabVideo.vue';
Vue.component('list-menu', menu);
Vue.component('list-head', head);
Vue.component('list-bottom', bottom);
Vue.component('videoElement', elabVideo);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js